/**
 * Een pagina met de copiloot ernaast (sessie 46, B6).
 *
 * Kennis, Gezondheid, Beheer, Signalen en Mijn profiel hadden geen
 * copilootkolom. Dit omhulsel zet hem rechts naast de inhoud, met
 * dezelfde maten als op Vandaag, en onder 900 px twee tabs: Pagina en
 * Copiloot. De pagina zegt de copiloot waar hij naar kijkt.
 */
import { useState, type ReactNode } from "react";

import { useKijkContext, useKijktMee } from "./kijktMee";
import { WerkplekCopiloot } from "./WerkplekCopiloot";

import "./copiloot.css";

export function MetCopiloot({
  pagina,
  children,
}: {
  /** De sleutel van de pagina: "kennis", "gezondheid", "beheer", ... */
  pagina: string;
  children: ReactNode;
}) {
  useKijktMee("pagina", null, pagina);
  const context = useKijkContext();
  const [tab, setTab] = useState<"pagina" | "copiloot">("pagina");
  return (
    <div className="wp-met-cp">
      <div className="wp-mobtabs wp-met-cp-tabs" role="tablist" aria-label="Pagina of copiloot">
        {(["pagina", "copiloot"] as const).map((welke) => (
          <button
            key={welke}
            type="button"
            role="tab"
            className="wp-knop"
            aria-selected={tab === welke}
            onClick={() => setTab(welke)}
          >
            {welke === "pagina" ? "Pagina" : "Copiloot"}
          </button>
        ))}
      </div>
      <div className="wp-met-cp-inhoud" data-mob-aan={tab === "pagina" ? "ja" : "nee"}>
        {children}
      </div>
      <div
        className="wp-kolom-copiloot wp-met-cp-kolom"
        data-mob-aan={tab === "copiloot" ? "ja" : "nee"}
      >
        <WerkplekCopiloot context={context} />
      </div>
    </div>
  );
}
